import Promotion26DContainer from "@/containers/Promotion/Promotion26DContainer";

export default function Promotion26DPage() {
  return <Promotion26DContainer />;
}
